var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.nome,"placement":"top-start"}},[_c('div',{staticClass:"progress-bar",style:({ width: (_vm.percentual + "%") , backgroundColor : _vm.color}),attrs:{"role":"progressbar","aria-valuenow":_vm.percentual,"aria-valuemin":"0","aria-valuemax":"100"}},[_vm._v("\n    "+_vm._s(_vm.valor)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca5570f4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/Dashboard/Components/Ranking/BarraProgresso.vue
// module id = 763
// module chunks = 1